class DevicePostureChecks {
    constructor(allAdmins, allDevicePostureChecks, blockUI) {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.form = document.querySelector('#frm-devicePostureCheckNotificationForm-devicePostureCheckNotificationForm');
        this.selectableAdmins = [];
        this.changesMade = false;

        this.initRepeater(allAdmins, allDevicePostureChecks ,blockUI);
        this.initFormValidation();
    }
    initFormValidation(){
        const thisClass = this;
        let submitButton = this.form.querySelector('button[data-type="submit"]');

        this.formValidator = FormValidation.formValidation(
            this.form,
            {
                plugins: {
                    trigger: new FormValidation.plugins.Trigger(),
                    autoFocus: new FormValidation.plugins.AutoFocus(),
                    submitButton: new FormValidation.plugins.SubmitButton(),
                    // defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                    bootstrap: new FormValidation.plugins.Bootstrap5({
                        rowSelector: '.fv-row',
                        eleInvalidClass: '',
                        eleValidClass: ''
                    }),
                }
            }
        );

        submitButton.addEventListener('click', function (e) {
            // Prevent default button action
            e.preventDefault();
            thisClass.formValidator.validate().then(function(status) {
                if(status === 'Valid'){
                    thisClass.saveChangesButton(true, false, false, true);

                    $(thisClass.form).submit();
                }
            });
        });

        let context = $.nette.ext(thisClass.form.id);
        if(!context){
            $.nette.ext(thisClass.form.id, {
                success: function (payload, status, jqXHR, settings) {
                    let formID = settings.nette.form[0].attributes.id.value;
                    if(formID === thisClass.form.id){
                        if(payload.success){
                            toastr.success(payload.message);
                        } else {
                            toastr.error(payload.message);
                        }

                        thisClass.changesMade = false;
                        thisClass.saveChangesButton(true, false, false, false);
                    }
                }
            });
        }
        $.nette.load();
    }
    async initRepeater(allAdmins, allDevicePostureChecks, blockUI) {
        const thisClass = this;
        const notEmptyValidator = {
            validators: {
                notEmpty: {
                    message: 'This field is required'
                }
            }
        };

        let devicePostureChecksAdminRepeater = $(this.form).find('#devicePostureCheck_wrapper').repeater({
            show: function () {
                thisClass.hideOrShowNoResults(true);

                $(this).slideDown();

                let devicePostureChecksInput = this.querySelector('input[data-kt-repeater="devicePostureChecks"]');
                thisClass.formValidator.addField(devicePostureChecksInput.name, notEmptyValidator);
                let devicePostureChecksTagify = new DevicePostureCheckTagify(devicePostureChecksInput, allDevicePostureChecks);
                devicePostureChecksTagify.on('add', function(e, tagData){
                    const addedValue = e.detail.data.value;
                    devicePostureChecksTagify.getTagElms().forEach(tag => {
                        if (addedValue === 'all' && tag.attributes.value.value !== 'all') {
                            devicePostureChecksTagify.removeTag(tag);
                        } else if(addedValue !== 'all' && tag.attributes.value.value === 'all'){
                            devicePostureChecksTagify.removeTag(tag);
                        }
                    });
                    thisClass.changesMade = true;
                    thisClass.saveChangesButton(false, true, false);
                }).on('remove', function(){
                    thisClass.changesMade = true;
                    thisClass.saveChangesButton(false, true, false);
                });

                let adminsInput = this.querySelector('input[data-kt-repeater="admins"]');
                thisClass.formValidator.addField(adminsInput.name, notEmptyValidator);
                const selectableAdmins = allAdmins.filter(admin =>
                    thisClass.selectableAdmins.includes(admin.value)
                );
                let adminsTagify = new AdminsTagify(adminsInput, selectableAdmins);
                adminsTagify.on('add', function(e, tagData){
                    const addedValue = e.detail.data.value;
                    adminsTagify.getTagElms().forEach(tag => {
                        if (addedValue === 'all' && tag.attributes.value.value !== 'all') {
                            adminsTagify.removeTag(tag);
                        } else if(addedValue !== 'all' && tag.attributes.value.value === 'all'){
                            adminsTagify.removeTag(tag);
                        }
                    });
                    thisClass.changesMade = true;
                    thisClass.saveChangesButton(false, true, false);
                }).on('remove', function(){
                    thisClass.changesMade = true;
                    thisClass.saveChangesButton(false, true, false);
                });
            },
            hide: function (deleteElement) {
                let numberOfItems = thisClass.form.querySelectorAll('[data-repeater-item]');
                if(numberOfItems.length === 1){
                    thisClass.hideOrShowNoResults(false);
                }

                let adminsName = $(this).find("input[name^='devicePostureChecksRecipients['][name$='][admins]']").attr('name');
                let devicePostureChecksName = $(this).find("input[name^='devicePostureChecksRecipients['][name$='][devicePostureChecks]']").attr('name');

                $(this).slideUp(deleteElement, function () {
                    thisClass.formValidator.removeField(adminsName);
                    thisClass.formValidator.removeField(devicePostureChecksName);

                    $(this).remove();
                    thisClass.changesMade = true;
                    thisClass.saveChangesButton(false, true, false);
                });
            }
        });

        let repeaterList = [];
        let organizationSettings = await this.getOrganizationSettings();
        for (let item of organizationSettings) {
            let admins = [];
            for(let adminValue of item['admins']){
                const admin = allAdmins.find(item => item.value === adminValue);
                admins.push(admin);
            }
            let devicePostureChecks = [];
            for(let devicePostureCheckValue of item['devicePostureChecks']){
                const devicePostureCheck = allDevicePostureChecks.find(item => item.value === devicePostureCheckValue);
                devicePostureChecks.push(devicePostureCheck);
            }

            const newItem = {
                admins: JSON.stringify(admins),
                devicePostureChecks: JSON.stringify(devicePostureChecks),
            };
            repeaterList.push(newItem);
        }
        devicePostureChecksAdminRepeater.setList(repeaterList);

        if(organizationSettings.length === 0){
            this.hideOrShowNoResults(false);
            this.saveChangesButton(true, false, true);
        } else {
            this.saveChangesButton(true, false, false);
        }
        blockUI.release();
    }
    async getOrganizationSettings() {
        const response = await fetch('/notifications/?do=getAdminDevicePostureChecksSettings&organizationID=' + this.organizationID);
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        const data = await response.json();
        this.selectableAdmins = data.selectableAdmins;
        return data.selectedPairs;
    }
    hideOrShowNoResults(hide = true){
        let devicePostureChecksNoResult = this.form.querySelector('.devicePostureChecks-no_result');
        if(devicePostureChecksNoResult){
            if(hide){
                devicePostureChecksNoResult.classList.add('d-none');
            } else {
                devicePostureChecksNoResult.classList.remove('d-none');
            }
        }
    }
    saveChangesButton(disabled = true, pulsing = true, hide = true, loading = false){
        let saveChangesBtn = this.form.querySelector('#saveChangesBtn');
        if(saveChangesBtn){
            saveChangesBtn.setAttribute('data-kt-indicator', loading ? 'on' : 'off');
            saveChangesBtn.disabled = disabled;
            let pulseBtn = saveChangesBtn.querySelector('#saveChangesPulse');
            if(!pulseBtn && pulsing){
                let pulseBtn = document.createElement("span");
                pulseBtn.classList.add('pulse-ring', 'top-0', 'start-0', 'w-100', 'h-100');
                pulseBtn.id = 'saveChangesPulse';
                saveChangesBtn.appendChild(pulseBtn);
            } else if(pulseBtn && !pulsing){
                pulseBtn.remove();
            }

            if(hide){
                saveChangesBtn.classList.add('d-none');
            } else {
                saveChangesBtn.classList.remove('d-none');
            }
        }
    }
}
window.DevicePostureChecks = DevicePostureChecks;